'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _kebabCase2 = require('lodash/kebabCase');

var _kebabCase3 = _interopRequireDefault(_kebabCase2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _constants = require('../../constants');

var _common = require('../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var TRANSITION_SLIDE = _constants.AppConstants.TRANSITION_SLIDE;

var ConfigurableReportsCheckboxGroup = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(ConfigurableReportsCheckboxGroup, _Component);

  _createClass(ConfigurableReportsCheckboxGroup, [{
    key: 'setFields',
    value: function setFields() {
      this.fields = this.props.fieldSets[this.props.title];
      this.isSectionShowing = this.fields.some(function (field) {
        return field.checked;
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.fieldSets[this.props.title] !== prevProps.fieldSets[prevProps.title]) {
        this.setFields();
      }
    }
  }, {
    key: 'sectionCheckboxState',
    get: function get() {
      var numberOfFields = this.fields.length,
          numberChecked = this.fields.filter(function (field) {
        return field.checked;
      }).length;

      if (numberChecked === 0) {
        return 'EMPTY';
      } else if (numberChecked === numberOfFields) {
        return 'FULL';
      }
      return 'PARTIAL';
    }
  }, {
    key: 'sectionCheckboxIsChecked',
    get: function get() {
      return this.sectionCheckboxState === 'FULL' || this.sectionCheckboxState === 'PARTIAL';
    }
  }]);

  function ConfigurableReportsCheckboxGroup(props) {
    _classCallCheck(this, ConfigurableReportsCheckboxGroup);

    var _this = _possibleConstructorReturn(this, (ConfigurableReportsCheckboxGroup.__proto__ || Object.getPrototypeOf(ConfigurableReportsCheckboxGroup)).call(this, props));

    _initDefineProp(_this, 'isSectionShowing', _descriptor, _this);

    _initDefineProp(_this, 'fields', _descriptor2, _this);

    _this.setFields();
    return _this;
  }

  _createClass(ConfigurableReportsCheckboxGroup, [{
    key: 'onSectionToggleClick',
    value: function onSectionToggleClick() {
      var fields = this.fields.map(function (field) {
        return field.fieldName;
      });
      this.toggleShowing();
      if (this.sectionCheckboxIsChecked) {
        this.props.clearSection(fields);
        this.fields = this.fields.map(function (field) {
          return _extends({}, field, { checked: false });
        });
      } else {
        this.props.fillSection(fields);
        this.fields = this.fields.map(function (field) {
          return _extends({}, field, { checked: true });
        });
      }
    }
  }, {
    key: 'toggleShowing',
    value: function toggleShowing() {
      this.isSectionShowing = !this.isSectionShowing;
    }
  }, {
    key: 'handleCheckboxChange',
    value: function handleCheckboxChange(e) {
      var _e$target = e.target,
          id = _e$target.id,
          checked = _e$target.checked;

      this.fields = this.fields.map(function (field) {
        if (field.fieldName === id) {
          return _extends({}, field, { checked: checked });
        }
        return field;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classNames = (0, _classnames2.default)('collapser-header', 'condensed-checkbox', { 'opened': this.isSectionShowing }),
          checkboxClassName = (0, _classnames2.default)({ 'checked-partial': this.sectionCheckboxState === 'PARTIAL' }),
          toggleIconType = this.isSectionShowing ? 'angle-double-up' : 'angle-double-down',
          titleInputId = (0, _kebabCase3.default)(this.props.title);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: classNames },
          _react2.default.createElement(
            _Button2.default,
            { bsStyle: 'link', onClick: this.toggleShowing, className: 'collapser-toggle pull-right' },
            _react2.default.createElement(_common.Icon, { type: toggleIconType })
          ),
          _react2.default.createElement('input', {
            id: titleInputId,
            className: checkboxClassName,
            type: 'checkbox',
            checked: this.sectionCheckboxIsChecked,
            onChange: this.onSectionToggleClick
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: titleInputId },
            ''
          ),
          _react2.default.createElement(
            'div',
            { className: 'title', onClick: this.toggleShowing },
            this.props.title
          )
        ),
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          TRANSITION_SLIDE,
          this.isSectionShowing && _react2.default.createElement(
            'div',
            { className: 'slider' },
            _react2.default.createElement(
              'div',
              { className: 'collapser-content' },
              _react2.default.createElement(
                'ul',
                { className: 'list-checkbox condensed-checkbox two-columns' },
                this.fields.map(function (field) {
                  return _react2.default.createElement(
                    'li',
                    { key: field.fieldName },
                    _react2.default.createElement('input', {
                      id: field.fieldName,
                      onChange: _this2.handleCheckboxChange,
                      type: 'checkbox',
                      checked: field.checked
                    }),
                    _react2.default.createElement(
                      'label',
                      { htmlFor: field.fieldName },
                      field.name
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ConfigurableReportsCheckboxGroup;
}(_react.Component), _class3.propTypes = {
  clearSection: _propTypes2.default.func.isRequired,
  fieldSets: _propTypes2.default.object.isRequired,
  fillSection: _propTypes2.default.func.isRequired,
  title: _propTypes2.default.string.isRequired
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'isSectionShowing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'fields', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'sectionCheckboxState', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'sectionCheckboxState'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'sectionCheckboxIsChecked', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'sectionCheckboxIsChecked'), _class2.prototype)), _class2)) || _class) || _class;

var _default = ConfigurableReportsCheckboxGroup;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TRANSITION_SLIDE, 'TRANSITION_SLIDE', '/app/src/components/page-reports/ConfigurableReportsCheckboxGroup.js');
  reactHotLoader.register(ConfigurableReportsCheckboxGroup, 'ConfigurableReportsCheckboxGroup', '/app/src/components/page-reports/ConfigurableReportsCheckboxGroup.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-reports/ConfigurableReportsCheckboxGroup.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2UtcmVwb3J0cy9Db25maWd1cmFibGVSZXBvcnRzQ2hlY2tib3hHcm91cC5qcyJdLCJuYW1lcyI6WyJUUkFOU0lUSU9OX1NMSURFIiwiQXBwQ29uc3RhbnRzIiwiQ29uZmlndXJhYmxlUmVwb3J0c0NoZWNrYm94R3JvdXAiLCJhdXRvQmluZE1ldGhvZHMiLCJvYnNlcnZlciIsImZpZWxkcyIsInByb3BzIiwiZmllbGRTZXRzIiwidGl0bGUiLCJpc1NlY3Rpb25TaG93aW5nIiwic29tZSIsImZpZWxkIiwiY2hlY2tlZCIsInByZXZQcm9wcyIsInNldEZpZWxkcyIsIm51bWJlck9mRmllbGRzIiwibGVuZ3RoIiwibnVtYmVyQ2hlY2tlZCIsImZpbHRlciIsInNlY3Rpb25DaGVja2JveFN0YXRlIiwibWFwIiwiZmllbGROYW1lIiwidG9nZ2xlU2hvd2luZyIsInNlY3Rpb25DaGVja2JveElzQ2hlY2tlZCIsImNsZWFyU2VjdGlvbiIsImZpbGxTZWN0aW9uIiwiZSIsInRhcmdldCIsImlkIiwiY2xhc3NOYW1lcyIsImNoZWNrYm94Q2xhc3NOYW1lIiwidG9nZ2xlSWNvblR5cGUiLCJ0aXRsZUlucHV0SWQiLCJvblNlY3Rpb25Ub2dnbGVDbGljayIsImhhbmRsZUNoZWNrYm94Q2hhbmdlIiwibmFtZSIsIkNvbXBvbmVudCIsInByb3BUeXBlcyIsIlByb3BUeXBlcyIsImZ1bmMiLCJpc1JlcXVpcmVkIiwib2JqZWN0Iiwic3RyaW5nIiwib2JzZXJ2YWJsZSIsImNvbXB1dGVkIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOztBQUNBOztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7Ozs7Ozs7QUFPQTs7QUFDQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFFUUEsZ0IsR0FBcUJDLHVCLENBQXJCRCxnQjs7SUFJRkUsZ0MsT0FGTEMsZ0MsZUFDQUMsbUI7Ozs7O2dDQUtjO0FBQ1gsV0FBS0MsTUFBTCxHQUFjLEtBQUtDLEtBQUwsQ0FBV0MsU0FBWCxDQUFxQixLQUFLRCxLQUFMLENBQVdFLEtBQWhDLENBQWQ7QUFDQSxXQUFLQyxnQkFBTCxHQUF3QixLQUFLSixNQUFMLENBQVlLLElBQVosQ0FBaUI7QUFBQSxlQUFTQyxNQUFNQyxPQUFmO0FBQUEsT0FBakIsQ0FBeEI7QUFDRDs7O3VDQUVtQkMsUyxFQUFXO0FBQzdCLFVBQUksS0FBS1AsS0FBTCxDQUFXQyxTQUFYLENBQXFCLEtBQUtELEtBQUwsQ0FBV0UsS0FBaEMsTUFBMkNLLFVBQVVOLFNBQVYsQ0FBb0JNLFVBQVVMLEtBQTlCLENBQS9DLEVBQXFGO0FBQ25GLGFBQUtNLFNBQUw7QUFDRDtBQUNGOzs7d0JBRzJCO0FBQzFCLFVBQU1DLGlCQUFpQixLQUFLVixNQUFMLENBQVlXLE1BQW5DO0FBQUEsVUFDSUMsZ0JBQWdCLEtBQUtaLE1BQUwsQ0FBWWEsTUFBWixDQUFtQjtBQUFBLGVBQVNQLE1BQU1DLE9BQWY7QUFBQSxPQUFuQixFQUEyQ0ksTUFEL0Q7O0FBR0EsVUFBSUMsa0JBQWtCLENBQXRCLEVBQXlCO0FBQ3ZCLGVBQU8sT0FBUDtBQUNELE9BRkQsTUFHSyxJQUFJQSxrQkFBa0JGLGNBQXRCLEVBQXNDO0FBQ3pDLGVBQU8sTUFBUDtBQUNEO0FBQ0QsYUFBTyxTQUFQO0FBQ0Q7Ozt3QkFHK0I7QUFDOUIsYUFBTyxLQUFLSSxvQkFBTCxLQUE4QixNQUE5QixJQUF3QyxLQUFLQSxvQkFBTCxLQUE4QixTQUE3RTtBQUNEOzs7QUFFRCw0Q0FBYWIsS0FBYixFQUFvQjtBQUFBOztBQUFBLG9LQUNaQSxLQURZOztBQUFBOztBQUFBOztBQUVsQixVQUFLUSxTQUFMO0FBRmtCO0FBR25COzs7OzJDQUV1QjtBQUN0QixVQUFNVCxTQUFTLEtBQUtBLE1BQUwsQ0FBWWUsR0FBWixDQUFnQjtBQUFBLGVBQVNULE1BQU1VLFNBQWY7QUFBQSxPQUFoQixDQUFmO0FBQ0EsV0FBS0MsYUFBTDtBQUNBLFVBQUksS0FBS0Msd0JBQVQsRUFBbUM7QUFDakMsYUFBS2pCLEtBQUwsQ0FBV2tCLFlBQVgsQ0FBd0JuQixNQUF4QjtBQUNBLGFBQUtBLE1BQUwsR0FBYyxLQUFLQSxNQUFMLENBQVllLEdBQVosQ0FBZ0I7QUFBQSw4QkFBY1QsS0FBZCxJQUFxQkMsU0FBUyxLQUE5QjtBQUFBLFNBQWhCLENBQWQ7QUFDRCxPQUhELE1BS0s7QUFDSCxhQUFLTixLQUFMLENBQVdtQixXQUFYLENBQXVCcEIsTUFBdkI7QUFDQSxhQUFLQSxNQUFMLEdBQWMsS0FBS0EsTUFBTCxDQUFZZSxHQUFaLENBQWdCO0FBQUEsOEJBQWNULEtBQWQsSUFBcUJDLFNBQVMsSUFBOUI7QUFBQSxTQUFoQixDQUFkO0FBQ0Q7QUFDRjs7O29DQUVnQjtBQUNmLFdBQUtILGdCQUFMLEdBQXdCLENBQUMsS0FBS0EsZ0JBQTlCO0FBQ0Q7Ozt5Q0FFcUJpQixDLEVBQUc7QUFBQSxzQkFDQ0EsRUFBRUMsTUFESDtBQUFBLFVBQ2ZDLEVBRGUsYUFDZkEsRUFEZTtBQUFBLFVBQ1hoQixPQURXLGFBQ1hBLE9BRFc7O0FBRXZCLFdBQUtQLE1BQUwsR0FBYyxLQUFLQSxNQUFMLENBQVllLEdBQVosQ0FBZ0IsaUJBQVM7QUFDckMsWUFBSVQsTUFBTVUsU0FBTixLQUFvQk8sRUFBeEIsRUFBNEI7QUFDMUIsOEJBQVdqQixLQUFYLElBQWtCQyxnQkFBbEI7QUFDRDtBQUNELGVBQU9ELEtBQVA7QUFDRCxPQUxhLENBQWQ7QUFNRDs7OzZCQUVTO0FBQUE7O0FBQ1IsVUFBTWtCLGFBQWEsMEJBQ2Ysa0JBRGUsRUFFZixvQkFGZSxFQUdmLEVBQUMsVUFBVSxLQUFLcEIsZ0JBQWhCLEVBSGUsQ0FBbkI7QUFBQSxVQUtJcUIsb0JBQW9CLDBCQUFHLEVBQUMsbUJBQW1CLEtBQUtYLG9CQUFMLEtBQThCLFNBQWxELEVBQUgsQ0FMeEI7QUFBQSxVQU1JWSxpQkFBaUIsS0FBS3RCLGdCQUFMLEdBQXdCLGlCQUF4QixHQUE0QyxtQkFOakU7QUFBQSxVQU9JdUIsZUFBZSx5QkFBVSxLQUFLMUIsS0FBTCxDQUFXRSxLQUFyQixDQVBuQjs7QUFTQSxhQUNFO0FBQUE7QUFBQTtBQUNFO0FBQUE7QUFBQSxZQUFLLFdBQVdxQixVQUFoQjtBQUNFO0FBQUMsNEJBQUQ7QUFBQSxjQUFRLFNBQVEsTUFBaEIsRUFBdUIsU0FBUyxLQUFLUCxhQUFyQyxFQUFvRCxXQUFVLDZCQUE5RDtBQUNFLDBDQUFDLFlBQUQsSUFBTSxNQUFNUyxjQUFaO0FBREYsV0FERjtBQUlFO0FBQ0UsZ0JBQUlDLFlBRE47QUFFRSx1QkFBV0YsaUJBRmI7QUFHRSxrQkFBSyxVQUhQO0FBSUUscUJBQVMsS0FBS1Asd0JBSmhCO0FBS0Usc0JBQVUsS0FBS1U7QUFMakIsWUFKRjtBQVdFO0FBQUE7QUFBQSxjQUFPLFNBQVNELFlBQWhCO0FBQStCO0FBQS9CLFdBWEY7QUFZRTtBQUFBO0FBQUEsY0FBSyxXQUFVLE9BQWYsRUFBdUIsU0FBUyxLQUFLVixhQUFyQztBQUFxRCxpQkFBS2hCLEtBQUwsQ0FBV0U7QUFBaEU7QUFaRixTQURGO0FBZUU7QUFBQyxpREFBRDtBQUE2QlIsMEJBQTdCO0FBQ0csZUFBS1MsZ0JBQUwsSUFDQztBQUFBO0FBQUEsY0FBSyxXQUFVLFFBQWY7QUFDRTtBQUFBO0FBQUEsZ0JBQUssV0FBVSxtQkFBZjtBQUNFO0FBQUE7QUFBQSxrQkFBSSxXQUFVLDhDQUFkO0FBQ0cscUJBQUtKLE1BQUwsQ0FBWWUsR0FBWixDQUFnQjtBQUFBLHlCQUNkO0FBQUE7QUFBQSxzQkFBSSxLQUFLVCxNQUFNVSxTQUFmO0FBQ0M7QUFDRSwwQkFBSVYsTUFBTVUsU0FEWjtBQUVFLGdDQUFVLE9BQUthLG9CQUZqQjtBQUdFLDRCQUFLLFVBSFA7QUFJRSwrQkFBU3ZCLE1BQU1DO0FBSmpCLHNCQUREO0FBT0M7QUFBQTtBQUFBLHdCQUFPLFNBQVNELE1BQU1VLFNBQXRCO0FBQWtDViw0QkFBTXdCO0FBQXhDO0FBUEQsbUJBRGM7QUFBQSxpQkFBaEI7QUFESDtBQURGO0FBREY7QUFGSjtBQWZGLE9BREY7QUF1Q0Q7Ozs7Ozs7Ozs7O0VBcEg0Q0MsZ0IsV0FzSHRDQyxTLEdBQVk7QUFDakJiLGdCQUFjYyxvQkFBVUMsSUFBVixDQUFlQyxVQURaO0FBRWpCakMsYUFBVytCLG9CQUFVRyxNQUFWLENBQWlCRCxVQUZYO0FBR2pCZixlQUFhYSxvQkFBVUMsSUFBVixDQUFlQyxVQUhYO0FBSWpCaEMsU0FBTzhCLG9CQUFVSSxNQUFWLENBQWlCRjtBQUpQLEMsMkZBckhsQkcsZ0I7OztXQUE4QixJOzsyRUFDOUJBLGdCOzs7V0FBb0IsRTs7MEVBYXBCQyxjLDZLQWNBQSxjOztlQWlHWTFDLGdDOzs7Ozs7Ozs7OzswQkFsSVBGLGdCOzBCQUlGRSxnQyIsImZpbGUiOiJDb25maWd1cmFibGVSZXBvcnRzQ2hlY2tib3hHcm91cC5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBvYnNlcnZlciB9IGZyb20gJ21vYngtcmVhY3QnO1xuaW1wb3J0IHsgb2JzZXJ2YWJsZSwgY29tcHV0ZWQgfSBmcm9tICdtb2J4JztcbmltcG9ydCBhdXRvQmluZE1ldGhvZHMgZnJvbSAnY2xhc3MtYXV0b2JpbmQtZGVjb3JhdG9yJztcbmltcG9ydCBSZWFjdENTU1RyYW5zaXRpb25Hcm91cCBmcm9tICdyZWFjdC1hZGRvbnMtY3NzLXRyYW5zaXRpb24tZ3JvdXAnO1xuaW1wb3J0IGN4IGZyb20gJ2NsYXNzbmFtZXMnO1xuaW1wb3J0IHsga2ViYWJDYXNlIH0gZnJvbSAnbG9kYXNoJztcblxuaW1wb3J0IHtcbiAgQnV0dG9uLFxufSBmcm9tICdyZWFjdC1ib290c3RyYXAnO1xuXG5pbXBvcnQgeyBBcHBDb25zdGFudHMgfSBmcm9tICcuLi8uLi9jb25zdGFudHMnO1xuaW1wb3J0IHsgSWNvbiB9IGZyb20gJy4uL2NvbW1vbic7XG5cbmNvbnN0IHsgVFJBTlNJVElPTl9TTElERSB9ID0gQXBwQ29uc3RhbnRzO1xuXG5AYXV0b0JpbmRNZXRob2RzXG5Ab2JzZXJ2ZXJcbmNsYXNzIENvbmZpZ3VyYWJsZVJlcG9ydHNDaGVja2JveEdyb3VwIGV4dGVuZHMgQ29tcG9uZW50IHtcbiAgQG9ic2VydmFibGUgaXNTZWN0aW9uU2hvd2luZyA9IHRydWU7XG4gIEBvYnNlcnZhYmxlIGZpZWxkcyA9IFtdO1xuXG4gIHNldEZpZWxkcyAoKSB7XG4gICAgdGhpcy5maWVsZHMgPSB0aGlzLnByb3BzLmZpZWxkU2V0c1t0aGlzLnByb3BzLnRpdGxlXTtcbiAgICB0aGlzLmlzU2VjdGlvblNob3dpbmcgPSB0aGlzLmZpZWxkcy5zb21lKGZpZWxkID0+IGZpZWxkLmNoZWNrZWQpO1xuICB9XG5cbiAgY29tcG9uZW50RGlkVXBkYXRlIChwcmV2UHJvcHMpIHtcbiAgICBpZiAodGhpcy5wcm9wcy5maWVsZFNldHNbdGhpcy5wcm9wcy50aXRsZV0gIT09IHByZXZQcm9wcy5maWVsZFNldHNbcHJldlByb3BzLnRpdGxlXSkge1xuICAgICAgdGhpcy5zZXRGaWVsZHMoKTtcbiAgICB9XG4gIH1cblxuICBAY29tcHV0ZWRcbiAgZ2V0IHNlY3Rpb25DaGVja2JveFN0YXRlICgpIHtcbiAgICBjb25zdCBudW1iZXJPZkZpZWxkcyA9IHRoaXMuZmllbGRzLmxlbmd0aFxuICAgICAgLCBudW1iZXJDaGVja2VkID0gdGhpcy5maWVsZHMuZmlsdGVyKGZpZWxkID0+IGZpZWxkLmNoZWNrZWQpLmxlbmd0aDtcblxuICAgIGlmIChudW1iZXJDaGVja2VkID09PSAwKSB7XG4gICAgICByZXR1cm4gJ0VNUFRZJztcbiAgICB9XG4gICAgZWxzZSBpZiAobnVtYmVyQ2hlY2tlZCA9PT0gbnVtYmVyT2ZGaWVsZHMpIHtcbiAgICAgIHJldHVybiAnRlVMTCc7XG4gICAgfVxuICAgIHJldHVybiAnUEFSVElBTCc7XG4gIH1cblxuICBAY29tcHV0ZWRcbiAgZ2V0IHNlY3Rpb25DaGVja2JveElzQ2hlY2tlZCAoKSB7XG4gICAgcmV0dXJuIHRoaXMuc2VjdGlvbkNoZWNrYm94U3RhdGUgPT09ICdGVUxMJyB8fCB0aGlzLnNlY3Rpb25DaGVja2JveFN0YXRlID09PSAnUEFSVElBTCc7XG4gIH1cblxuICBjb25zdHJ1Y3RvciAocHJvcHMpIHtcbiAgICBzdXBlcihwcm9wcyk7XG4gICAgdGhpcy5zZXRGaWVsZHMoKTtcbiAgfVxuXG4gIG9uU2VjdGlvblRvZ2dsZUNsaWNrICgpIHtcbiAgICBjb25zdCBmaWVsZHMgPSB0aGlzLmZpZWxkcy5tYXAoZmllbGQgPT4gZmllbGQuZmllbGROYW1lKTtcbiAgICB0aGlzLnRvZ2dsZVNob3dpbmcoKTtcbiAgICBpZiAodGhpcy5zZWN0aW9uQ2hlY2tib3hJc0NoZWNrZWQpIHtcbiAgICAgIHRoaXMucHJvcHMuY2xlYXJTZWN0aW9uKGZpZWxkcyk7XG4gICAgICB0aGlzLmZpZWxkcyA9IHRoaXMuZmllbGRzLm1hcChmaWVsZCA9PiAoey4uLmZpZWxkLCBjaGVja2VkOiBmYWxzZX0pKTtcbiAgICB9XG5cbiAgICBlbHNlIHtcbiAgICAgIHRoaXMucHJvcHMuZmlsbFNlY3Rpb24oZmllbGRzKTtcbiAgICAgIHRoaXMuZmllbGRzID0gdGhpcy5maWVsZHMubWFwKGZpZWxkID0+ICh7Li4uZmllbGQsIGNoZWNrZWQ6IHRydWV9KSk7XG4gICAgfVxuICB9XG5cbiAgdG9nZ2xlU2hvd2luZyAoKSB7XG4gICAgdGhpcy5pc1NlY3Rpb25TaG93aW5nID0gIXRoaXMuaXNTZWN0aW9uU2hvd2luZztcbiAgfVxuXG4gIGhhbmRsZUNoZWNrYm94Q2hhbmdlIChlKSB7XG4gICAgY29uc3QgeyBpZCwgY2hlY2tlZCB9ID0gZS50YXJnZXQ7XG4gICAgdGhpcy5maWVsZHMgPSB0aGlzLmZpZWxkcy5tYXAoZmllbGQgPT4ge1xuICAgICAgaWYgKGZpZWxkLmZpZWxkTmFtZSA9PT0gaWQpIHtcbiAgICAgICAgcmV0dXJuIHsuLi5maWVsZCwgY2hlY2tlZH07XG4gICAgICB9XG4gICAgICByZXR1cm4gZmllbGQ7XG4gICAgfSk7XG4gIH1cblxuICByZW5kZXIgKCkge1xuICAgIGNvbnN0IGNsYXNzTmFtZXMgPSBjeChcbiAgICAgICAgJ2NvbGxhcHNlci1oZWFkZXInLFxuICAgICAgICAnY29uZGVuc2VkLWNoZWNrYm94JyxcbiAgICAgICAgeydvcGVuZWQnOiB0aGlzLmlzU2VjdGlvblNob3dpbmd9LFxuICAgICAgKVxuICAgICAgLCBjaGVja2JveENsYXNzTmFtZSA9IGN4KHsnY2hlY2tlZC1wYXJ0aWFsJzogdGhpcy5zZWN0aW9uQ2hlY2tib3hTdGF0ZSA9PT0gJ1BBUlRJQUwnfSlcbiAgICAgICwgdG9nZ2xlSWNvblR5cGUgPSB0aGlzLmlzU2VjdGlvblNob3dpbmcgPyAnYW5nbGUtZG91YmxlLXVwJyA6ICdhbmdsZS1kb3VibGUtZG93bidcbiAgICAgICwgdGl0bGVJbnB1dElkID0ga2ViYWJDYXNlKHRoaXMucHJvcHMudGl0bGUpO1xuXG4gICAgcmV0dXJuIChcbiAgICAgIDxkaXY+XG4gICAgICAgIDxkaXYgY2xhc3NOYW1lPXtjbGFzc05hbWVzfT5cbiAgICAgICAgICA8QnV0dG9uIGJzU3R5bGU9J2xpbmsnIG9uQ2xpY2s9e3RoaXMudG9nZ2xlU2hvd2luZ30gY2xhc3NOYW1lPSdjb2xsYXBzZXItdG9nZ2xlIHB1bGwtcmlnaHQnPlxuICAgICAgICAgICAgPEljb24gdHlwZT17dG9nZ2xlSWNvblR5cGV9IC8+XG4gICAgICAgICAgPC9CdXR0b24+XG4gICAgICAgICAgPGlucHV0XG4gICAgICAgICAgICBpZD17dGl0bGVJbnB1dElkfVxuICAgICAgICAgICAgY2xhc3NOYW1lPXtjaGVja2JveENsYXNzTmFtZX1cbiAgICAgICAgICAgIHR5cGU9J2NoZWNrYm94J1xuICAgICAgICAgICAgY2hlY2tlZD17dGhpcy5zZWN0aW9uQ2hlY2tib3hJc0NoZWNrZWR9XG4gICAgICAgICAgICBvbkNoYW5nZT17dGhpcy5vblNlY3Rpb25Ub2dnbGVDbGlja31cbiAgICAgICAgICAvPlxuICAgICAgICAgIDxsYWJlbCBodG1sRm9yPXt0aXRsZUlucHV0SWR9PnsnJ308L2xhYmVsPlxuICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPSd0aXRsZScgb25DbGljaz17dGhpcy50b2dnbGVTaG93aW5nfT57dGhpcy5wcm9wcy50aXRsZX08L2Rpdj5cbiAgICAgICAgPC9kaXY+XG4gICAgICAgIDxSZWFjdENTU1RyYW5zaXRpb25Hcm91cCB7Li4uVFJBTlNJVElPTl9TTElERX0+XG4gICAgICAgICAge3RoaXMuaXNTZWN0aW9uU2hvd2luZyAmJlxuICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9J3NsaWRlcic+XG4gICAgICAgICAgICAgIDxkaXYgY2xhc3NOYW1lPSdjb2xsYXBzZXItY29udGVudCc+XG4gICAgICAgICAgICAgICAgPHVsIGNsYXNzTmFtZT0nbGlzdC1jaGVja2JveCBjb25kZW5zZWQtY2hlY2tib3ggdHdvLWNvbHVtbnMnPlxuICAgICAgICAgICAgICAgICAge3RoaXMuZmllbGRzLm1hcChmaWVsZCA9PlxuICAgICAgICAgICAgICAgICAgICAoPGxpIGtleT17ZmllbGQuZmllbGROYW1lfT5cbiAgICAgICAgICAgICAgICAgICAgICA8aW5wdXRcbiAgICAgICAgICAgICAgICAgICAgICAgIGlkPXtmaWVsZC5maWVsZE5hbWV9XG4gICAgICAgICAgICAgICAgICAgICAgICBvbkNoYW5nZT17dGhpcy5oYW5kbGVDaGVja2JveENoYW5nZX1cbiAgICAgICAgICAgICAgICAgICAgICAgIHR5cGU9J2NoZWNrYm94J1xuICAgICAgICAgICAgICAgICAgICAgICAgY2hlY2tlZD17ZmllbGQuY2hlY2tlZH1cbiAgICAgICAgICAgICAgICAgICAgICAvPlxuICAgICAgICAgICAgICAgICAgICAgIDxsYWJlbCBodG1sRm9yPXtmaWVsZC5maWVsZE5hbWV9PntmaWVsZC5uYW1lfTwvbGFiZWw+XG4gICAgICAgICAgICAgICAgICAgIDwvbGk+KVxuICAgICAgICAgICAgICAgICAgKX1cbiAgICAgICAgICAgICAgICA8L3VsPlxuICAgICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICAgIH1cbiAgICAgICAgPC9SZWFjdENTU1RyYW5zaXRpb25Hcm91cD5cbiAgICAgIDwvZGl2PlxuICAgICk7XG4gIH1cblxuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIGNsZWFyU2VjdGlvbjogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbiAgICBmaWVsZFNldHM6IFByb3BUeXBlcy5vYmplY3QuaXNSZXF1aXJlZCxcbiAgICBmaWxsU2VjdGlvbjogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbiAgICB0aXRsZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IENvbmZpZ3VyYWJsZVJlcG9ydHNDaGVja2JveEdyb3VwO1xuIl19